/**
 * Logikk for AI-diagnose og anbefalingsmotor
 */

export const diagnoseResults = (metrics) => {
  const findings = [];
  const risks = [];
  const interventions = [];
  const workshops = [];

  // 1. Analyse av Psykologisk Trygghet
  if (metrics.psychSafety < 50) {
    risks.push({
      area: "Psykologisk Trygghet",
      level: "Høy",
      impact: "Høy risiko for taushetskultur og manglende innovasjon.",
      score: metrics.psychSafety
    });
    interventions.push("Gjennomføre anonyme dybdeintervjuer for å avdekke fryktkultur.");
    workshops.push("Introduksjon til psykologisk trygghet", "Ytringskultur (Speaking up)");
  }

  // 2. Analyse av Konflikt
  if (metrics.conflictScore > 60) {
    risks.push({
      area: "Konfliktnivå",
      level: "Kritisk",
      impact: "Direkte påvirkning på produktivitet og psykisk helse.",
      score: metrics.conflictScore
    });
    interventions.push("Ekstern konfliktmekling for ledergruppen.");
    workshops.push("Forståelse av konflikter", "Strategier for konfliktløsning");
  }

  // 3. Analyse av Stress og Arbeidsbelastning
  if (metrics.stressScore > 70) {
    risks.push({
      area: "Arbeidsrelatert Stress",
      level: "Kritisk",
      impact: "Høy sannsynlighet for økt sykefravær de neste 3-6 månedene.",
      score: metrics.stressScore
    });
    interventions.push("Gjennomgang av ressursfordeling og prioriteringer i teamet.");
    workshops.push("Stressmestring i hverdagen", "Prioritering av arbeidsoppgaver");
  }

  // 4. Analyse av Ledelse
  if (metrics.leadershipScore < 55) {
    findings.push("Lederstøtte oppleves som utilstrekkelig i endringsprosesser.");
    interventions.push("Etablere faste 1-til-1 samtaler med fokus på mestring.");
    workshops.push("Lederkommunikasjon", "Støtte til ansattes trivsel");
  }

  // Generer Executive Summary basert på kritikalitet
  let summary = "Arbeidsmiljøet preges av god stabilitet, men med enkelte forbedringspunkter.";
  if (metrics.stressScore > 70 || metrics.psychSafety < 40) {
    summary = "Kritiske avvik identifisert. Umiddelbare tiltak anbefales for å forebygge sykefravær og turnover.";
  }

  return {
    summary,
    findings,
    risks,
    interventions,
    workshops,
    riskLevel: metrics.stressScore > 80 ? 'Critical' : metrics.stressScore > 60 ? 'High' : 'Moderate'
  };
};